import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LessBtn, MoreBtn } from "../../images/icons/JsxIcons";
import "../../styles/components/addLessDiv.css";
export default function AddLessDiv({
  classname = "",
  title = "",
  setData,
  data,
  max = 10000,
  min = 0,
  baseData = null,
  checkCallBefore = null,
  required = false,
  mineId = "mine-just-add-less-div",
}) {
  const { t } = useTranslation();
  useEffect(() => {
    if (baseData) {
      let newData = baseData;
      if (baseData > max) newData = max;
      setData(newData);
    }
  }, [baseData]);
  // console.log("data", max);
  const handleAdd = () => {
    if (checkCallBefore) checkCallBefore();
    if (data < max) {
      setData(data + 1);
    }
  };
  const handleLess = () => {
    if (data > min) {
      setData(data - 1);
    }
  };
  return (
    <div
      id={mineId}
      className={`nbr-config ${classname} | flrow center btw rlve`}
    >
      {required && data <= min && (
        <span className="required">{t("modals.addLessDiv.required")}</span>
      )}
      <label>{title}</label>
      <div className="nbrs | flrow center">
        <button
          onClick={handleLess}
          disabled={data <= min}
          className="btn-nbr | btn"
        >
          <LessBtn stroke={data <= min ? "#9CA3AF" : "#1E1A21"} />
        </button>
        <span className={`${data > 0 && "on-true"}`}>
          {data < 10 ? "0" + data : data}
        </span>
        <button
          onClick={handleAdd}
          disabled={data >= max}
          className="btn-nbr | btn"
        >
          <MoreBtn stroke={data >= max ? "#9CA3AF" : "#1E1A21"} />
        </button>
      </div>
    </div>
  );
}
